module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabList"
  }, _vm._l((_vm.list), function(item) {
    return _c('tabItem', {
      attrs: {
        "itemData": item,
        "value": _vm.value
      },
      on: {
        "select": _vm.selectTab
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-754c9224!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabTitle/tabList.vue
// module id = 1546
// module chunks = 18